import { oqulyqtarApi } from "../api";

const userListApi = oqulyqtarApi.injectEndpoints({
  endpoints: (build) => ({
    getUsersList: build.query({
      query: (filters) => ({
        url: `/user/list${filters && filters}`,
        method: "GET",
      }),
    }),
    getSubscriptionUserList: build.query({
      query: (filters) => ({
        url: `/subscription/user-list${filters && filters}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useLazyGetUsersListQuery, useLazyGetSubscriptionUserListQuery } =
  userListApi;
